module.exports = __webpack_public_path__ + "static/img/03.c9c0e88.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cultours/tour5/03.jpg
// module id = aI7M
// module chunks = 0